export default __webpack_public_path__ + "static/media/avatar_134.50ec70ea.png";